import React, { memo, Fragment } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { PanelGroup } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import SelectedFilePanel from './SelectedFilePanel';
import SelectedFile from '../entity/SelectedFile';

const FilesToImportList = ({
    t,
    deleteFile,
    files,
    columnGridCount,
}) => (
    <Fragment>
        <h3>{`${t('theme.dropzone.selected_files')}:`}</h3>
        <PanelGroup id="files-to-import">
            {files.map(file => (
                <SelectedFilePanel
                    deleteFile={deleteFile}
                    file={file}
                    key={file.getId()}
                    columnGridCount={columnGridCount}
                />
            ))}
        </PanelGroup>
    </Fragment>
);

FilesToImportList.propTypes = {
    t: PropTypes.func.isRequired,
    deleteFile: PropTypes.func.isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(SelectedFile)).isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    withTranslation('DropZone'),
    memo,
)(FilesToImportList);
